import { render, staticRenderFns } from "./modelList.vue?vue&type=template&id=3557370e"
import script from "./modelList.vue?vue&type=script&lang=js"
export * from "./modelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports